<template>
    <div class="container">
        <div id="login-box">
            <div class="row" style="height: 66px;">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <div v-if="loginError !== null" class="alert alert-danger" role="alert">
                        {{loginError}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <form class="form-horizontal" @submit.prevent="login">
                        <div class="row">
                            <div class="col-md-3"></div>
                            <div class="col-md-6">
                                <h2>Kérem jelentkezzen be</h2>
                                <hr>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3"></div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="sr-only" for="username">Felhasználónév</label>
                                    <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <i class="fa fa-user"></i>
                                            </div>
                                        </div>
                                        <input
                                            id="username"
                                            type="text"
                                            class="form-control"
                                            placeholder="Felhasználónév"
                                            v-model="username"
                                            required
                                            autofocus
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3"></div>
                        </div>
                        <div class="row">
                            <div class="col-md-3"></div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="sr-only" for="password">Jelszó</label>
                                    <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <i class="fa fa-lock"></i>
                                            </div>
                                        </div>
                                        <input
                                            id="password"
                                            type="password"
                                            class="form-control"
                                            placeholder="Jelszó"
                                            v-model="password"
                                            required
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3"></div>
                        </div>
                        <div class="row" style="padding-top: 1rem">
                            <div class="col-md-3"></div>
                            <div class="col-md-6">
                                <button type="submit" class="btn btn-success">
                                    <i v-if="loading" class="fa fa-spin fa-refresh"></i>
                                    <i v-else class="fa fa-sign-in"></i>
                                    Bejelentkezés
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import md5 from 'md5';

    export default{
        name: 'Login',
        data(){
            return {
                username: '',
                password: '',
            }
        },
        computed: {
            loading(){
                return this.$store.state.LoginModul.loading;
            },
            isLogged(){
                return this.$store.getters['LoginModul/isLogged'];
            },
            loginError(){
                return this.$store.state.LoginModul.error;
            }
        },
        watch:{
            isLogged(){
                if(this.isLogged === true){
                    this.username = '';
                    this.password = '';
                    this.$router.push('/');
                }
            }
        },
        methods:{
            login(){
                let data = {
                    username: this.username,
                    password: md5(this.password)
                };

                this.$store.dispatch('LoginModul/login', data);
            }
        }
    }
</script>

<style>
    #login-box{
        height: 320px;
        margin-top: calc(50vh - 220px);
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue